import { useRouter } from "next/router";
import { api } from "@/src/utils/api";

export type AnalyticsPagesAvailability = { lia: boolean; mcp: boolean };

/**
 * Which custom analytics pages apply to the project in the URL.
 * `undefined` while unknown — the navigation filter hides the entries until
 * the answer arrives, so a project never flashes a link it cannot open.
 */
export function useAnalyticsPages(): AnalyticsPagesAvailability | undefined {
  const router = useRouter();
  const projectId = router.query.projectId as string | undefined;
  const { data } = api.analyticsPages.getEnabled.useQuery(
    { projectId: projectId as string },
    {
      enabled: Boolean(projectId),
      staleTime: Infinity, // depende solo de env del server: no cambia en caliente
      // SIN `retry: false` a propósito (2026-08-25): con él, UN fallo transitorio
      // de este query dejaba `data` en undefined y el filtro de navegación
      // escondía las DOS entradas del menú hasta recargar la pestaña entera. El
      // endpoint solo lee env (no toca DB ni FS), así que reintentar es barato.
      refetchOnWindowFocus: false,
    },
  );
  return data;
}
